import { render, staticRenderFns } from "./RequestMail.vue?vue&type=template&id=6a532801&scoped=true&"
import script from "./RequestMail.vue?vue&type=script&lang=js&"
export * from "./RequestMail.vue?vue&type=script&lang=js&"
import style0 from "./RequestMail.vue?vue&type=style&index=0&id=6a532801&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a532801",
  null
  
)

export default component.exports